module.exports = __webpack_public_path__ + "img/location-question.37661227.svg";